export default "__VITE_ASSET__5coDUIqB__"